import inView from 'in-view';

const cartSubmit = () => {

  const checkoutBtn = document.querySelector('.c-cta--newsletter');
  const floatingBtn = document.getElementById('cart_submit');

  if(checkoutBtn && floatingBtn) {

    inView('.c-cta--newsletter')
      .on('enter', () => {
        floatingBtn.classList.add('is-outofscope');
      })
      .on('exit', () => {
        floatingBtn.classList.remove('is-outofscope');
      });

  }
}

cartSubmit()
